<template>
  <fragment v-if="documents.length > 0">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col"
              style="border: 0px;"></th>
          <th scope="col"
              class="borderHide">Document Name</th>
          <th scope="col"
              class="borderHide">Uploaded On</th>
          <th scope="col"
              class="borderHide"></th>
          <th scope="col"
              class="borderHide"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(doc, index) in documents"
            :key="index">
          <th scope="row">
            <i class="fa fa-file"
               style="font-size: 16px;"></i>
          </th>
          <td>{{ doc.name }}</td>
          <td>{{ dateFormatter(doc.uploaded_on) }}</td>
          <td>
            <a class="btn btn-danger el-button--default float-right"
               target="_blank"
               :href="doc.fileURL">
              View
            </a>
          </td>
          <td>
            <a href="#"
               class="btn btn-danger el-button--default float-left"
               @click.prevent="remove(index, doc.id)">
              Remove
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </fragment>
</template>

<script>
import { dateFormatter } from '@Views/Screening/utility/common';
import { File } from "@Views/Screening/utility/apiAgent";

export default {
  name: "DocumentTable",
  props: {
    documents: {
      type: Array
    }
  },
  data() {
    return {}
  },
  methods: {
    dateFormatter,
    remove(index, applicantFileId) {
      File.deleteDocument(applicantFileId)
        .then(({ data }) => {
          this.documents.splice(index, 1);
          //Fire an Event With Id of File.
          this.$emit('onDelete', index);
          this.$toastr.s(data.message);
        });
    },
  }
}
</script>

<style scoped>
.borderHide {
  border-left: 1px;
  border-right: 1px;
  border-top: 0px;
  border-bottom: 0px;
}
</style>